import { render, staticRenderFns } from "./RoundsTable.vue?vue&type=template&id=3ced6119&scoped=true&"
import script from "./RoundsTable.vue?vue&type=script&lang=js&"
export * from "./RoundsTable.vue?vue&type=script&lang=js&"
import style0 from "./RoundsTable.vue?vue&type=style&index=0&id=3ced6119&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ced6119",
  null
  
)

export default component.exports